import mainLogo from "@/assets/logos/main.png";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { ADMIN_ROUTES, NAV_ITEMS } from "@/constants";
import { logout } from "@/features/auth/authSlice";
import { useAppDispatch } from "@/hooks/useRedux";
import { LogOut } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export function AppSidebar() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate(ADMIN_ROUTES.LOGIN.link);
  };

  return (
    <Sidebar variant="floating">
      <SidebarHeader className="border-b border-sidebar-border">
        <div className="flex  justify-center items-center gap-2 px-4 py-3">
          <div className="flex justify-center">
            <img src={mainLogo} alt="Mind Match Logo" className="h-16 w-auto" />
          </div>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {NAV_ITEMS.map((item) => {
                const isActive =
                  item.url === "/"
                    ? location.pathname === "/"
                    : location.pathname.startsWith(item.url);

                return (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton
                      className={`
                        justify-start py-4
                        ${
                          isActive
                            ? "bg-teal! text-yellow! font-bold! border-2! border-yellow! hover:bg-teal/90!"
                            : "text-foreground hover:bg-sidebar-accent border-2 border-transparent"
                        }
                      `}
                      asChild
                      isActive={isActive}
                    >
                      <Link
                        to={item.url}
                        className="flex items-center gap-2"
                        // style={isActive ? { textShadow: '1px 1.2px 0 #000' } : {}}
                      >
                        <item.icon
                          className={isActive ? "w-5 h-5" : "w-5 h-5"}
                          // style={isActive ? { filter: 'drop-shadow(1px 1.2px 0 #000)' } : {}}
                        />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="border-t border-sidebar-border">
        <SidebarMenu>
          <SidebarMenuButton onClick={handleLogout}>
            <LogOut />
            <span>Logout</span>
          </SidebarMenuButton>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
